/*
 * @Author: Chao Yang
 * @Date: 2021-06-21 00:41:20
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-12-28 09:49:31
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdDocViewerComponent } from './ad-doc-viewer/ad-doc-viewer.component';
import { AdImgViewerComponent } from './ad-img-viewer/ad-img-viewer.component';
import { AdPdfViewerComponent } from './ad-pdf-viewer/ad-pdf-viewer.component';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { AdExcelViewerComponent } from './ad-excel-viewer/ad-excel-viewer.component';
import { AdSkeletonModule } from '../ad-skeleton/ad-skeleton.module';
import { AdVideoViewerComponent } from './ad-video-viewer/ad-video-viewer.component';
import { AdButtonModule } from '../ad-button/ad-button.module';


@NgModule({
  declarations: [AdDocViewerComponent, AdImgViewerComponent, AdPdfViewerComponent, AdExcelViewerComponent, AdVideoViewerComponent],
  imports: [
    CommonModule,
    VirtualScrollerModule,
    AdSkeletonModule,
    AdButtonModule
  ],
  exports: [AdDocViewerComponent, AdImgViewerComponent, AdPdfViewerComponent, AdExcelViewerComponent, AdVideoViewerComponent],
  //entryComponents: [AdDocViewerComponent]
})
export class AdDocViewerModule { }

export { AdDocViewerComponent, AdImgViewerComponent, AdPdfViewerComponent, AdExcelViewerComponent, AdVideoViewerComponent };
